import React from "react";
import { ShimmerLine } from "../../Shimmer/ShimmerLine/ShimmerLine";
import { SlotStack, SlotStackItem } from "../../Stacks/SlotStack/SlotStack";

export const SensitiveContentShimmer: React.FC = () => {
    return (
        <SlotStack totalSlots={12}>
            <SlotStackItem slots={1} >
                <></>
            </SlotStackItem>
            <SlotStackItem slots={8}>
                <ShimmerLine height={12} />
            </SlotStackItem>
            <SlotStackItem slots={2}>
                <ShimmerLine height={12} />
            </SlotStackItem>
            <SlotStackItem slots={1}>
                <></>
            </SlotStackItem>
        </SlotStack>
    );
};
